import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';

export const CLEAR_CALLBACKS_LIST_DETAILS = "CLEAR_CALLBACKS_LIST_DETAILS";
export const FETCH_CALLBACKS_LIST_SUCCESS = "FETCH_CALLBACKS_LIST_SUCCESS";
export const FETCH_CALLBACKS_LIST_FAILED = "FETCH_CALLBACKS_LIST_FAILED";
export const FETCH_CALLBACKS_LIST_LOADING = "FETCH_CALLBACKS_LIST_LOADING";
export const CLEAR_CALLBACKS_LIST_STATUS = "CLEAR_CALLBACKS_LIST_STATUS";

export const SETTINGS_LOADING = "SETTINGS_LOADING";
export const SETTINGS_FAILED  = "SETTINGS_FAILED";
export const SETTINGS_LOADING_SUCCESS  = "SETTINGS_LOADING_SUCCESS";

export const C2C_SETTINGS_LOADING = "SETTINGS_LOADING";
export const C2C_SETTINGS_FAILED  = "SETTINGS_FAILED";
export const C2C_SETTINGS_LOADING_SUCCESS  = "SETTINGS_LOADING_SUCCESS";

export const COUNTRY_SLOT_LOADING = "COUNTRY_SLOT_LOADING";
export const COUNTRY_SLOT_FAILED  = "COUNTRY_SLOT_FAILED";
export const COUNTRY_SLOT_SUCCESS  = "COUNTRY_SLOT_SUCCESS";

export const fetchCallbacks = (data: any) => {
    let { limit, offset } = data

    return (dispatch: Dispatch<any>) => {

        let loadingType = FETCH_CALLBACKS_LIST_LOADING;
        let successType = FETCH_CALLBACKS_LIST_SUCCESS;
        let failedType = FETCH_CALLBACKS_LIST_FAILED;
        let URL = `/paginate-cb-profile?`;

        if (limit) {
            URL += `limit=${limit}&offset=${offset * limit}`
        } else {
            URL += `limit=1000`
        } 

        dispatch({ type: loadingType });
        networkCall("get", URL, apiBaseUrl.baseUrl).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                dispatch({ type: successType, payload: res });
            } else {
                dispatch({ type: failedType, payload: { error: res } });
            }
        }).catch((err) => {
            if (err?.response?.data) {
                dispatch({ type: failedType, payload: { error: err.response.data } });
            }
        });
    }
}

export const getSettings = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SETTINGS_LOADING });

        let failedType: string = SETTINGS_FAILED;

        let url: string = `/voice-settings`;

        networkCall("get", url, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: SETTINGS_LOADING_SUCCESS, payload: { respose: res } });
                } else {
                    dispatch({ type: failedType, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: failedType, payload: { error: error.response.data } });
                }
            });
    }

}

export const getClickToCallSettings = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: C2C_SETTINGS_LOADING });

        let failedType: string = C2C_SETTINGS_FAILED;

        let url: string = `/click-to-call-settings`;

        networkCall("get", url, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error) && !isEmpty(res.data)) {
                    dispatch({ type: C2C_SETTINGS_LOADING_SUCCESS, payload: { respose: res } });
                } else {
                    dispatch({ type: failedType, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: failedType, payload: { error: error.response.data } });
                }
            });
    }

}

export const saveRequest = (data: any, cb: (message: string, status: boolean) => void) => {
    return (dispatch: Dispatch<any>) => {

        let url: string = `/voice-settings`;

        networkCall("post", url, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    cb(res.message, true);
                } else {
                    cb(res.message, false);
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    let message = error.response.data.message;

                    // update error message to make use readable
                    if (error?.response?.data?.error?.scalar) {
                        message = error?.response?.data?.error?.scalar;  
                    }

                    cb(message, false);
                }
            });
    }

}

export const saveClickToCallRequest = (data: any, cb: (message: string, status: boolean) => void) => {
    return (dispatch: Dispatch<any>) => {

        let url: string = `/click-to-call-settings`;

        networkCall("post", url, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    cb(res.message, true);
                } else {
                    cb(res.message, false);
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    let message = error.response.data.message;

                    // update error message to make use readable
                    if (error?.response?.data?.error?.scalar) {
                        message = error?.response?.data?.error?.scalar;  
                    }

                    cb(message, false);
                }
            });
    }

}

export const fetchCountrySlots = (data: any) => {
    let { country_id, call_service_id } = data

    return (dispatch: Dispatch<any>) => {

        let loadingType = COUNTRY_SLOT_LOADING;
        let successType = COUNTRY_SLOT_SUCCESS;
        let failedType  = COUNTRY_SLOT_FAILED;

        let URL = `/timeout-profiles`;

        if (country_id) {
            URL += `?country_id=${country_id}&call_service_id=${call_service_id}`
        }

        dispatch({ type: loadingType });
        networkCall("get", URL, apiBaseUrl.baseUrl).then((res: any) => {
            if (res.error && isEmpty(res.error)) {

                dispatch({ type: successType, payload: { response: res } });
            } else {
                dispatch({ type: failedType, payload: { error: res } });
            }
        }).catch((err) => {
            if (err?.response?.data) {
                dispatch({ type: failedType, payload: { error: err.response.data } });
            }
        });
    }
}